export { default as ViewTrendButton } from './ViewTrendButton';
